export default "__VITE_ASSET__9b46ce99__"